/**
 * Section Comment ça marche - Version Finale
 * Avec support du mode horizontal slider sur mobile
 */

class HowItWorksHorizontal {
  constructor(container) {
    console.log('🎬 Initializing How It Works Horizontal', container);
    
    this.container = container;
    this.stepsContainer = container.querySelector('.steps-horizontal');
    this.steps = container.querySelectorAll('.step-item');
    
    console.log('📊 Found steps:', this.steps.length);
    
    if (!this.steps.length) {
      console.warn('⚠️ No steps found!');
      return;
    }
    
    this.currentStep = 0;
    this.autoplayInterval = null;
    this.duration = parseInt(this.container.dataset.autoplayDuration || 4) * 1000;
    this.isHovered = false;
    this.isMobile = window.innerWidth <= 989;
    this.isScrolling = false; // Flag pour éviter les conflits de scroll
    
    console.log('⏱️ Autoplay duration:', this.duration, 'ms');
    console.log('📱 Mobile mode:', this.isMobile);
    
    this.init();
    this.setupResizeListener();
  }
  
  init() {
    console.log('✅ Initializing horizontal steps...');
    
    // Activer la première étape
    this.goToStep(0);
    
    // Ajouter les événements de clic
    this.setupClickEvents();
    
    // Configurer pause au survol
    this.setupHoverPause();
    
    // Configurer la détection de scroll sur mobile
    if (this.isMobile) {
      this.setupScrollDetection();
    }
    
    // Démarrer l'autoplay
    this.startAutoplay();
    
    console.log('🎉 Horizontal steps initialized successfully!');
  }
  
  goToStep(index) {
    console.log('➡️ Going to step:', index);
    
    // Retirer l'état actif de tous les steps
    this.steps.forEach((step, i) => {
      step.classList.remove('active');
      if (i === index) {
        step.classList.add('active');
        console.log(`  Step ${i}: activated`);
      }
    });
    
    this.currentStep = index;
    
    // Sur mobile, toujours scroller le container (autoplay et user)
    if (this.isMobile && this.stepsContainer) {
      this.isScrolling = true; // Flag pour ignorer la détection de scroll
      this.scrollToStep(index);
      
      // Désactiver le flag après le scroll
      setTimeout(() => {
        this.isScrolling = false;
      }, 600);
    }
  }
  
  scrollToStep(index) {
    const step = this.steps[index];
    if (step && this.stepsContainer) {
      // Calculer la position exacte de l'étape
      const scrollPosition = step.offsetLeft;
      
      // Scroller UNIQUEMENT le container horizontal (pas toute la page)
      this.stepsContainer.scrollTo({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  }
  
  nextStep() {
    const next = (this.currentStep + 1) % this.steps.length;
    this.goToStep(next);
  }
  
  prevStep() {
    const prev = (this.currentStep - 1 + this.steps.length) % this.steps.length;
    this.goToStep(prev);
  }
  
  setupClickEvents() {
    this.steps.forEach((step, index) => {
      step.addEventListener('click', () => {
        console.log('👆 Step clicked:', index);
        this.goToStep(index);
        this.resetAutoplay();
      });
      
      // Améliorer l'accessibilité
      step.setAttribute('role', 'button');
      step.setAttribute('tabindex', '0');
      step.setAttribute('aria-label', 'Étape ' + (index + 1));
      
      // Support clavier
      step.addEventListener('keypress', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          console.log('⌨️ Step activated via keyboard:', index);
          this.goToStep(index);
          this.resetAutoplay();
        }
      });
    });
  }
  
  setupHoverPause() {
    // Pause sur le container entier
    this.container.addEventListener('mouseenter', () => {
      console.log('⏸️ Paused (hover)');
      this.isHovered = true;
      this.stopAutoplay();
    });
    
    this.container.addEventListener('mouseleave', () => {
      console.log('▶️ Resumed (leave)');
      this.isHovered = false;
      this.startAutoplay();
    });
    
    // Pause aussi sur mobile avec touch
    this.container.addEventListener('touchstart', () => {
      this.isHovered = true;
      this.stopAutoplay();
    }, { passive: true });
    
    // Reprendre après quelques secondes sans toucher
    let touchTimeout;
    this.container.addEventListener('touchend', () => {
      clearTimeout(touchTimeout);
      touchTimeout = setTimeout(() => {
        this.isHovered = false;
        this.startAutoplay();
      }, 3000);
    }, { passive: true });
  }
  
  // Détecte le scroll manuel et active l'étape la plus centrée
  setupScrollDetection() {
    if (!this.stepsContainer) return;
    
    let scrollTimeout;
    
    this.stepsContainer.addEventListener('scroll', () => {
      // Ignorer si c'est un scroll automatique
      if (this.isScrolling) {
        return;
      }
      
      clearTimeout(scrollTimeout);
      
      // Attendre que le scroll se stabilise
      scrollTimeout = setTimeout(() => {
        if (this.isMobile && !this.isScrolling) {
          const containerCenter = this.stepsContainer.scrollLeft + this.stepsContainer.offsetWidth / 2;
          
          let closestIndex = 0;
          let closestDistance = Infinity;
          
          this.steps.forEach((step, index) => {
            const stepCenter = step.offsetLeft + step.offsetWidth / 2;
            const distance = Math.abs(containerCenter - stepCenter);
            
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          
          // Activer l'étape la plus proche du centre
          if (closestIndex !== this.currentStep) {
            console.log('📜 Scroll detected, activating step:', closestIndex);
            this.currentStep = closestIndex;
            
            this.steps.forEach((step, i) => {
              if (i === closestIndex) {
                step.classList.add('active');
              } else {
                step.classList.remove('active');
              }
            });
            
            this.resetAutoplay();
          }
        }
      }, 150);
    }, { passive: true });
  }
  
  setupResizeListener() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 989;
        
        // Si on change de mode (mobile <-> desktop)
        if (wasMobile !== this.isMobile) {
          console.log('🔄 Mode changed:', this.isMobile ? 'Mobile' : 'Desktop');
          
          if (this.isMobile) {
            this.setupScrollDetection();
          }
        }
      }, 250);
    });
  }
  
  startAutoplay() {
    if (this.isHovered) return;
    
    this.stopAutoplay(); // Clear any existing interval
    console.log('▶️ Starting autoplay');
    
    this.autoplayInterval = setInterval(() => {
      if (!this.isHovered) {
        console.log('⏭️ Autoplay: next step');
        this.nextStep();
      }
    }, this.duration);
  }
  
  stopAutoplay() {
    if (this.autoplayInterval) {
      console.log('⏹️ Stopping autoplay');
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
  
  resetAutoplay() {
    console.log('🔄 Resetting autoplay');
    this.stopAutoplay();
    this.startAutoplay();
  }
}

// Initialiser tous les containers sur la page
document.addEventListener('DOMContentLoaded', () => {
  console.log('🚀 DOM Content Loaded - Looking for horizontal steps...');
  const containers = document.querySelectorAll('.steps-container');
  console.log('Found containers:', containers.length);
  
  containers.forEach((container, index) => {
    console.log(`Initializing horizontal steps ${index + 1}/${containers.length}`);
    new HowItWorksHorizontal(container);
  });
});

// Support pour les sections dynamiques de Shopify (Theme Editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    console.log('🔧 Shopify section loaded');
    const container = event.target.querySelector('.steps-container');
    if (container) {
      new HowItWorksHorizontal(container);
    }
  });
}